export enum ShareMarketStatus {
  Active = 1,
  Dehosting = 2,
  Halt = 3,
  Inactive = 4,
  Suspend = 5,
}
